import React from 'react';
import { Box, Select } from '@chakra-ui/react';

export const QUIZ_TYPE_FILTER_OPTIONS = [
    { value: 'PRACTICE', label: 'Practice' },
    { value: 'ASSESSMENT', label: 'Assessment' },
] as const;

export type LibraryQuizTypeFilter = (typeof QUIZ_TYPE_FILTER_OPTIONS)[number]['value'];

type Props = {
    value: string;
    onChange: (quizType: string) => void;
};

export const QuizTypeFilter: React.FC<Props> = ({ value, onChange }) => (
    <Box flex="1 1 9.5rem" minW="9.5rem" maxW="11rem">
        <Select
            aria-label="Filter by quiz type"
            bg="white"
            borderRadius="1000px"
            borderColor="gray.200"
            fontSize="sm"
            fontWeight="normal"
            h="2.5rem"
            w="100%"
            value={value}
            onChange={(e) => onChange(e.target.value)}>
            <option value="">All Quiz Types</option>
            {QUIZ_TYPE_FILTER_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                    {opt.label}
                </option>
            ))}
        </Select>
    </Box>
);
